import { FC, useContext } from "react";
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { HospitalGapsFlyout } from "@app/projects/network-assessment/provider-hub/hospital-profile/HospitalGapsFlyout";
import { AccessGapTypeEnum } from "@app/projects/network-assessment/provider-hub/enumerators";
import { GapRegionStatusAnnotation } from "@app/projects/network-assessment/provider-hub/GapRegionStatusAnnotation";
import { QESButtonTypeClasses } from "@app/shared/qes-standards/Button";

export const HospitalProfileKeyPoints: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedHospital } = providerHubContext;
  const accessPointCount = selectedHospital.accessPointCount;
  const specialtyCount = selectedHospital.servicingSpecialties;

  return (
    <div className="provider-profile__card">
      <h4 className="provider-profile__card-title">Key Points</h4>
      <div className="provider-profile__card-content">
        <div className="provider-profile__card-values">
          <div className="provider-profile__card-highlight" aria-labelledby="access-points">{accessPointCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="specialties">{specialtyCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="gap-impact">
            {selectedHospital.gapsImpact == null
              ? "---"
              : selectedHospital.gapsImpact === 0
                ? 0
                : (<FlyoutLink
                      classNames={QESButtonTypeClasses.get("link")}
                      testId="hospital-profile__gap-impact"
                      content={{
                        body: <HospitalGapsFlyout gapType={AccessGapTypeEnum.FillableBySingleProvider} />,
                        title: "Gap Closure"
                      }}>
                        {selectedHospital.gapsImpact}
                    </FlyoutLink>)
            }
            <GapRegionStatusAnnotation
              total={selectedHospital.gapsImpact}
              active={selectedHospital.activeGapsImpact}
              pending={selectedHospital.pendingGapsImpact}
              approved={selectedHospital.approvedGapsImpact}
              opportunity={selectedHospital.opportunityGapsImpact}
              useGapsByRegionStatus={selectedHospital.useGapsByRegionStatus}
            />
          </div>
        </div>

        <div className="provider-profile__card-labels">
          <div className="provider-profile__card-subtitle" id="access-points">Access Points</div>
          <div className="provider-profile__card-subtitle" id="specialties">Specialty Groups</div>
          <div className="provider-profile__card-subtitle" id="gap-impact">Gap Impact</div>
        </div>
      </div>
    </div>
  );
};
